import PageSkeleton from "@/components/PageSkeleton"

export default function Loading() {
  return <PageSkeleton loading name="work-article" />
}
